<template>
  <Layout style="height: 100%" class="main" v-if="showRouter">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div v-show="!collapsed" class="logo-con">
          <img :src="lang === 'en' ? maxEnLogo : maxLogo" key="max-logo" />
        </div>
        <div v-show="collapsed" class="logo-con-min">
          <img :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :user-avator="userAvator"/>
          <switchSys/>
          <Language />

          <!-- <MessageCenter @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/> -->
          <fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>
          <!-- 三维看板按钮 -->
          <div v-if="showThreeDDashboard" class="three-d-dashboard-btn" @click="openThreeDDashboard" style="margin-right: 15px;margin-top: 1px">
            <Icon type="ios-cube" :size="48" style="color: #2d8cf0; margin-right: 6px;"></Icon>
            <span class="btn-text">{{ langMap.threeDDashboard[lang] }}</span>
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList" v-if="mainInitialized">
              <router-view/>
            </keep-alive>
            <div v-else class="loading-placeholder">
              <!-- 可以添加加载提示 -->
              <Spin size="large"></Spin>
            </div>
            <ABackTop :height="100" :bottom="80" :right="50" container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>

    <!-- 紧急通知容器 -->
    <div id="emergency-notification-container"></div>
  </Layout>
</template>
<script>
import api from "@/api"
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import MessageCenter from './components/language'
import ErrorStore from './components/error-store'
import ErrorNotification from '@/view/monitor/dashboard/module/error/ErrorNotification.vue'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.png'
import maxLogo from '@/assets/images/logo.png'
import maxEnLogo from '@/assets/images/logo-en.png'
import userFace from '@/assets/images/user-face.jpg'
import switchSys from '@/components/switchSys/index.vue';
import Language from '@/components/Language/index.vue';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { connectWithUrl }  from '@/utils/websocket'
import Vue from 'vue'
import * as timeUtil from "@/utils/dateTimeUtil.js";

import './main.less'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    MessageCenter,
    TagsNav,
    Language,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop,
    switchSys
  },
  data () {
    return {
      langMap:langMap,
      collapsed: false,
      minLogo,
      maxLogo,
      maxEnLogo,
      isFullscreen: false,

      //是否显示页面
      showRouter:false,
      // 添加主组件初始化完成标识
      mainInitialized: false,
      warningNoticeId:'',
      sentimentId: '',
      warningMuteUntil: localStorage.getItem('warningMuteUntil') || 0,  // 从localStorage读取
      sentimentMuteUntil: localStorage.getItem('sentimentMuteUntil') || 0, // 从localStorage读取

      // 三维看板相关
      showThreeDDashboard: false, // 是否显示三维看板按钮
      threeDDashboardUrl: '', // 三维看板URL
      
      // 事件监听器处理器
      muteEventHandler: null,
      customEventHandler: null,
      sentimentEventHandler: null,
      
      // 去重：记录最后一次通知的时间戳
      lastWarningTimestamp: 0,
      lastSentimentTimestamp: 0
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    ...mapGetters([
      'errorCount'
    ]),
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvator () {
      return userFace;
    },
    cacheList () {
      return ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
    },
    menuList () {
      return this.$store.state.app.sysMenulist
    },
    local () {
      return this.$store.state.app.local
    },
    hasReadErrorPage () {
      return this.$store.state.app.hasReadErrorPage
    }
  },
  watch: {
    '$route' (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },


  created(){
    this.getUserInfo();

    // 检查是否显示三维看板按钮
    const thdime = sessionStorage.getItem('thdime');
    if (thdime === '1') {
      this.showThreeDDashboard = true;
      // 获取三维看板配置
      this.getThreeDDashboardConfig();
    }
  },


  mounted () {
    // 移除旧的监听器（如果存在）
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
    
    // 添加 custom-event 监听器
    this.customEventHandler = (event) => {
       // console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有网枪记录页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/gunRecord',
            name: 'gunRecord',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.gunOperate(false, event.detail.data); break;
        case 3: this.gunOperate(true, event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_gun')
    };
    document.body.addEventListener("custom-event", this.customEventHandler);
    
    // 添加 sentiment-custom-event 监听器
    this.sentimentEventHandler = (event) => {
      console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有告警处理页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/alarmHandling',
            name: 'alarmHandling',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.switchVideo(event.detail.data); break;
        case 3: this.sentimentOperate(event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_sentiment')
    };
    document.body.addEventListener("sentiment-custom-event", this.sentimentEventHandler);
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 设置初始语言
    this.setLocal(this.$i18n.locale)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }

    // 添加时间单位切换函数到window对象
    window.setTimeUnit = (id, element, multiplier) => {
      // 移除其他单位的active类
      const units = element.parentElement.getElementsByClassName('time-unit');
      Array.from(units).forEach(unit => unit.classList.remove('active'));
      // 添加active类到当前单位
      element.classList.add('active');
      // 保存乘数到input的data属性
      document.getElementById(`muteTime_${id}`).dataset.multiplier = multiplier;
    };

    // 添加静默事件监听器
    this.muteEventHandler = (event) => {
      const { type, id, value } = event.detail;
      if (!value) {
        this.$Message.warning('请选择或输入时间');
        return;
      }
      this.setMuteTime(type, value);
    };
    document.body.addEventListener("mute-event", this.muteEventHandler);

    // 添加 select change 事件监听
    document.body.addEventListener("change", (event) => {
      if (event.target.classList.contains('time-select')) {
        const customInput = event.target.nextElementSibling;
        if (customInput && customInput.classList.contains('custom-time-input')) {
          customInput.style.display = event.target.value === 'custom' ? 'inline-block' : 'none';
        }
      }
    });

    // 添加全局引用以便在内联JavaScript中使用
    window.app = this;
    this.ratioW()
  },

  beforeDestroy() {
    delete window.app;

    // 关闭 WebSocket 连接
    if (window._globalWebsockets && window._globalWebsockets.length > 0) {
      window._globalWebsockets.forEach(ws => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.close();
          console.log('WebSocket 连接已关闭');
        }
      });
      // 清空全局 WebSocket 数组
      window._globalWebsockets = [];
    }

    // 关闭所有 Notice 弹窗
    this.$Notice.destroy();

    // 移除所有事件监听器
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
  },

  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute'
    ]),
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage(this.$config.homeName)
      } else if (routeEqual(this.$route, route)) {
        if (type !== 'others') {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    },

    //更新后台允许访问菜单数组
    getUserInfo(){
      this.showRouter=false;
      this.$Spin.show();
      api.getData('system-server/user/get/home/date',this).then((res)=>{
        this.$Spin.hide();
        if(res.state==0){
          this.showRouter=false;
          //跳转错误页面
          this.$router.push({
              name: 'error_500'
          });
        }else{
          if(!res.data.menu.length){
            // 没有菜单数据，显示提示并跳转到登录页
            this.$Modal.info({
              title: langMap.noMenuPermission[this.lang],
              content: langMap.noMenuPermissionMessage[this.lang],
              okText: langMap.confirm[this.lang],
              onOk: () => {
                // 清除用户信息并跳转到登录页
                this.$store.commit('logOut');
                this.$router.push({
                  name: 'login'
                });
              }
            });
            return;
          }
          //保存全局动态菜单数据
          this.$store.commit('updateMenulist',res.data.menu);
          this.$store.commit('muChnageUserInfo', res.data.loginUser);
          this.$store.commit('setBreadCrumb', this.$route);
          this.showRouter=true;
          //console.log(res.data.loginUser)
          this.socketInit('msgSocketUrl', res.data.loginUser.userId, this.callback, this);

          this.loadComplete()
          // this.warning({data:{msg:'请求打开网枪',img:''}});
        }
      })
    },
    socketInit(key, userId, callback, _this){
      connectWithUrl('/ssf', key, userId, callback);
    },
    loadComplete() {
      this.$nextTick(() => {
        // 通知全局主组件已初始化完成
        this.mainInitialized = true;
      });
    },
    callback(data){
      const ret = JSON.parse(data);
      switch (ret.type) {
        case '1':
          this.$Notice.info({
            title: langMap.systemMessage[this.lang],
            desc: ret.data
          });
          break;
          case 'gun:': this.warning(ret); break;
          case 'sentiment:': this.sentiment(ret); break;
          case 'emergency_info': this.emergencyNotice(ret); break;
          default:
      }
    },
    createNoticeHtml(data, type) {
      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';

      const customEvent = type === 'warning' ?
        'custom-event' :
        'sentiment-custom-event';

      return `
        <div class="notice-container">
          <h2 class="notice-title">${this.langMap.targetDetected[this.lang]}</h2>
          <img class="notice-img" src="${data.data.img}"/>
          <div class="notice-content">
            <div class="mute-settings">
              <div class="time-input-wrapper">
                <div class="error-tip" id="errorTip_${id}"></div>
                <span class="mute-label">${this.langMap.ignore[this.lang]}:</span>
                <select class="time-select" id="muteTime_${id}">
                  <option value="30">30${this.langMap.second[this.lang]}</option>
                  <option value="60">60${this.langMap.second[this.lang]}</option>
                  <option value="90">90${this.langMap.second[this.lang]}</option>
                  <option value="120">120${this.langMap.second[this.lang]}</option>
                  <option value="custom">${this.langMap.customize[this.lang]}</option>
                </select>
                <input type="number" class="custom-time-input" id="customTime_${id}" style="display:none" min="1" placeholder="${this.langMap.second[this.lang]}"/>
                <button class="mute-confirm" onclick='javascript:
                  try {
                    var errorTip = document.getElementById("errorTip_${id}");
                    var select = document.getElementById("muteTime_${id}");
                    var customInput = document.getElementById("customTime_${id}");
                    errorTip.textContent = ""; // 清除之前的错误提示

                    if (!select) {
                      errorTip.textContent = "系统错误：找不到选择框元素";
                      return;
                    }
                    var value = select.value;
                    if (value === "custom") {
                      value = customInput.value;
                      if (!value) {
                        errorTip.textContent = "${this.langMap.PleaseInputTime[this.lang]}";
                        customInput.focus();
                        return;
                      }
                      if (value <= 0) {
                        errorTip.textContent = "${this.langMap.PleaseInputMax[this.lang]}";
                        customInput.focus();
                        return;
                      }
                    }
                    document.body.dispatchEvent(new CustomEvent("mute-event", {
                      detail: {
                        type: "${type}",
                        id: "${id}",
                        value: value
                      }
                    }));
                  } catch(e) {
                    errorTip.textContent = e.message;
                  }
                '>${this.langMap.confirm[this.lang]}</button>
              </div>
            </div>
            <div class="action-buttons">
              <Button class="btn primary" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:1,data:data})}});document.body.dispatchEvent(k);'>${this.langMap.details[this.lang]}</Button>
              <Button class="btn danger" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:3,data:data})}});document.body.dispatchEvent(k);'>${type === 'warning' ? this.langMap.allow[this.lang] : this.langMap.noDeal[this.lang]}</Button>
            </div>
          </div>
        </div>`;
    },

    showNotice(data, type) {
      const currentTime = Date.now();
      const storageKey = type === 'warning' ? 'warningMuteUntil' : 'sentimentMuteUntil';
      const savedMuteUntil = parseInt(localStorage.getItem(storageKey)) || 0;

      // 检查是否在静默期
      if (currentTime < savedMuteUntil) {
        return;
      }

      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';
      
      // 去重：500ms 内不重复显示同一条通知
      const lastTimestamp = type === 'warning' ? this.lastWarningTimestamp : this.lastSentimentTimestamp;
      const messageId = data.data.messageId || data.data.code;
      if (currentTime - lastTimestamp < 500 && (type === 'warning' ? this.warningNoticeId : this.sentimentId) === id) {
        return;
      }
      
      if (type === 'warning') {
        this.lastWarningTimestamp = currentTime;
      } else {
        this.lastSentimentTimestamp = currentTime;
      }

      // 关闭之前的通知
      this.$Notice.close(type === 'warning' ? this.warningNoticeId : this.sentimentId);

      // 保存当前通知ID
      if (type === 'warning') {
        this.warningNoticeId = id;
      } else {
        this.sentimentId = id;
      }

      // 显示通知
      this.$Notice.warning({
        key: id,
        name: id,
        title: this.langMap.robot[this.lang] + ':' + data.data.code,
        desc: this.createNoticeHtml(data, type),
        duration: 0
      });
    },

    warning(data) {
      this.showNotice(data, 'warning');
    },

    sentiment(data) {
      this.showNotice(data, 'sentiment');
    },

    emergencyNotice(data) {
      const action = data.data && data.data.action ? data.data.action : '';
      const reason = data.data && data.data.reason ? data.data.reason : '';
      const robotName = data.robotName || '';
      const robotId = data.robotId || '';
      const robotCode = data.robotCode || '';
      const dataTime = (data.data && data.data.dataTime) ? timeUtil.formatTime(data.data.dataTime) : ''

      let descContent = '';
      descContent += `${this.langMap.robot[this.lang]}：${robotName}<br/>`;
      descContent += `${this.langMap.dashboard_robotCode[this.lang]}：${robotCode}<br/>`;
      descContent += `${this.langMap.action[this.lang]}：${action && this.langMap[action][this.lang]}`;
      if (descContent && !descContent.endsWith('<br/>')) descContent += '<br/>';
      descContent += `${this.langMap.reason[this.lang]}：${reason && this.langMap[reason][this.lang]}<br/>`;
      descContent += `${this.langMap.dashboard_dataTime[this.lang]}：${dataTime}`;

      // 创建一个 div 容器
      const container = document.createElement('div');
      document.body.appendChild(container);

      // 创建 ErrorNotification 组件实例，传入当前 Vue 实例的上下文
      const NotificationConstructor = Vue.extend(ErrorNotification);
      const instance = new NotificationConstructor({
        parent: this, // 传入父组件，这样可以继承 store 等上下文
        propsData: {
          title: this.langMap.emergencyNotificationTitle[this.lang],
          description: descContent || this.langMap.emergencyNotificationTitle[this.lang],
          type: 'emergency',
          duration: 10000,
          robotId: robotId
        }
      });

      // 挂载组件
      instance.$mount(container);

      // 监听关闭事件，销毁组件
      instance.$on('close', () => {
        instance.$destroy();
        if (container.parentNode) {
          document.body.removeChild(container);
        }
      });

      // 监听忽略事件
      instance.$on('ignore', () => {
        instance.$destroy();
        if (container.parentNode) {
          document.body.removeChild(container);
        }
      });
    },

    gunOperate(type, data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: type ? langMap.confirmOpenNetGun[this.lang] : langMap.confirmRejectOperation[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            flag: type
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/gun", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    switchVideo(data) {
      let routedata = this.$router.resolve({
        path: "/lol",
        query: {
          id: data.robotId,
          timestamp: data.data.timestamp,
        }
      });
      window.open(routedata.href, "_blank");
    },
    sentimentOperate(data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: langMap.confirmIgnoreAlarm[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            ret: 4
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/sentiment", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tips[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    // 设置静默时间
    setMuteTime(type, seconds) {
      const value = parseInt(seconds);
      if (!value || value <= 0) {
        this.$Message.warning({
          content: this.langMap.enterValidTime[this.lang],
          duration: 3
        });
        return;
      }

      const muteUntil = Date.now() + value * 1000;

      if (type === 'warning') {
        this.warningMuteUntil = muteUntil;
        localStorage.setItem('warningMuteUntil', muteUntil);
        this.$Notice.close(this.warningNoticeId);
      } else {
        this.sentimentMuteUntil = muteUntil;
        localStorage.setItem('sentimentMuteUntil', muteUntil);
        this.$Notice.close(this.sentimentId);
      }

      const reminderMsg = this.langMap.reminderNotGiveAgain[this.lang].replace('{seconds}', value);
      this.$Message.success({
        content: reminderMsg,
        duration: 3
      });
    },
    //自适应屏幕
    ratioW(text) {
      var targetWidth = text || 1600;
      var style = document.createElement("style");
      style.innerHTML = `
         body {
           width: 100%;
           height: 100%;
           margin: 0;
         }
         `;
      document.head.appendChild(style);

      let adjustWindow = () => {
        let ratio = window.innerWidth / targetWidth;
        if (ratio > 1) ratio = 1;
        const defaultZoom = document.documentElement.getAttribute("defaultZoom")
        if(defaultZoom){
          ratio = parseFloat(ratio > defaultZoom ? defaultZoom : ratio)
        }
        document.documentElement.style.zoom = ratio;

        document.documentElement.setAttribute("data-ratio", ratio);
      };
      adjustWindow();
      window.addEventListener("resize", adjustWindow);
      // 使鼠标坐标一致
      let x_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "x").get;
      let y_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "y").get;
      Object.defineProperties(MouseEvent.prototype, {
        R: {
          get: function () {
            return parseFloat(document.documentElement.getAttribute("data-ratio"));
          },
        },
        x: {
          get: function () {
            return x_get.call(this) / this.R;
          },
        },
        y: {
          get: function () {
            return y_get.call(this) / this.R;
          },
        },
      });
    },

    // 获取三维看板配置
    getThreeDDashboardConfig() {
      api.getData("system-server/config/list?keys=3dDashboardUrl").then(r => {
        if (r.state == 0) {
          console.error(r.msg);
        } else {
          let config = r.data['3dDashboardUrl']
          if (config && config.configValue) {
            this.threeDDashboardUrl = config.configValue
          }
        }
      })
    },

    // 打开三维看板
    openThreeDDashboard() {
      if (!this.threeDDashboardUrl) {
        this.$Message.error(this.langMap.swConfigNotFound[this.lang]);
        return;
      }
      try {
        // 跳转到三维看板
        window.location.href = this.threeDDashboardUrl;
      } catch (error) {
        console.error('Error opening 3D dashboard:', error);
        this.$Message.error(this.langMap.openFailed[this.lang]);
      }
    },

    // 跳转到页面，避免重复标签
    navigateToPageWithoutDuplicateTag(routeConfig) {
      const { name, path, query } = routeConfig;
      
      // 检查标签栏中是否已存在同名路由
      const existingTag = this.tagNavList.find(item => item.name === name);
      
      if (existingTag) {
        // 如果已存在，先关闭旧标签
        const newTagList = this.tagNavList.filter(item => item.name !== name);
        this.setTagNavList(newTagList);
      }
      
      // 跳转到新路由（watch 会自动添加新标签）
      this.$router.push({ path, query });
    }
  }

}
</script>
<style>
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    background: #EC5336 !important;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title{
    background:#0f0f0f !important;
  }
  .ivu-menu-vertical,.ivu-menu-opened{
    background:#0f0f0f !important;
  }
  .ivu-menu-dark{
    background: #030202 !important;
  }
  .ivu-layout-sider{
    background: #030202 !important;
  }
  .btn{
    margin: 5px;
    padding: 5px 10px;
  }
  .mute-select-container {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mute-select {
    width: 100px;
  }

  .mute-confirm {
    margin-left: 8px;
  }

  .notice-container {
    padding: 8px;
  }

  .notice-title {
    font-size: 17px;
    color: #ed4014;
    font-weight: bold;
  }

  .notice-img {
    border-radius: 4px;
    width: 120px;
    height: 120px;
    display: block;
  }

  .notice-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mute-settings {
    margin-bottom: 4px;
  }

  .time-input-wrapper {
    position: relative;  /* 添加相对定位 */
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f8f8f9;
    padding: 4px 6px;
    border-radius: 4px;
  }

  .error-tip {
    position: absolute;
    top: -20px;  /* 位于输入框上方 */
    left: 0;
    right: 0;
    text-align: center;
    color: #ed4014;
    font-size: 12px;
    min-height: 16px;
    padding: 0 4px;
  }

  /* 当有错误提示时，增加上边距 */
  .time-input-wrapper:has(.error-tip:not(:empty)) {
    margin-top: 20px;
  }

  .mute-label {
    color: #e46f2b;
    font-size: 13px;
    white-space: nowrap;
    font-weight: bold;
  }

  .time-select {
    height: 24px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    padding: 0 4px;
    background: white;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 65px;
  }

  .time-select:focus {
    border-color: #2d8cf0;
  }

  .custom-time-input {
    width: 60px;
    height: 24px;
    padding: 0 4px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    transition: all 0.3s;
    text-align: center;
  }

  .custom-time-input:focus {
    border-color: #2d8cf0;
  }

  .mute-confirm {
    height: 24px;
    padding: 0 8px;
    font-size: 12px;
    color: #fff;
    background: #2d8cf0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
  }

  .action-buttons {
    display: flex;
    gap: 4px;
    margin-top: 4px;
  }

  .btn {
    flex: 1;
    padding: 3px 8px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    margin: 0;
  }

  .btn.primary {
    background: #2db7f5;
  }

  .btn.warning {
    background: #ff9900;
  }

  .btn.danger {
    background: #ed4014;
  }

  .btn:hover {
    opacity: 0.85;
  }

  /* 三维看板按钮样式 */
  .three-d-dashboard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    height: 63px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.1), rgba(45, 140, 240, 0.15));
    border: 1px solid rgba(45, 140, 240, 0.3);
    font-weight: 500;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(45, 140, 240, 0.1);
  }

  .three-d-dashboard-btn .btn-text {
    color: #2d8cf0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .three-d-dashboard-btn:hover {
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.2), rgba(45, 140, 240, 0.25));
    border-color: rgba(45, 140, 240, 0.5);
    box-shadow: 0 4px 12px rgba(45, 140, 240, 0.25);
  }

  .three-d-dashboard-btn:hover .btn-text {
    color: #1c7cd6;
  }

  .three-d-dashboard-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(45, 140, 240, 0.2);
  }
</style>
